import React from 'react';
import './Services.scss';

const services = [
  {
    title: 'Büroreinigung',
    text: 'Saubere Arbeitsplätze fördern Konzentration und Wohlbefinden. Wir sorgen für eine gründliche und regelmäßige Reinigung Ihrer Büroräume – zuverlässig und diskret.',
  },
  {
    title: 'Treppenhausreinigung',
    text: 'Der erste Eindruck zählt. Unsere professionelle Treppenhausreinigung sorgt für gepflegte Eingangsbereiche und ein sauberes Erscheinungsbild Ihres Gebäudes.',
  },
  {
    title: 'Reinigung von Monteurunterkünften',
    text: 'Wir reinigen Monteurunterkünfte schnell, gründlich und hygienisch – damit Ihre Gäste sich jederzeit wohlfühlen. Ideal für regelmäßige oder einmalige Reinigung.',
  },
  {
    title: 'Wohnungsreinigung',
    text: 'Ob Einzug, Auszug oder regelmäßige Reinigung – wir bringen Glanz und Frische in jede Wohnung, ganz nach Ihren individuellen Wünschen.',
  },
  {
    title: 'Hausmeisterdienste',
    text: 'Wir kümmern uns um alle kleinen Dinge, die Ihr Gebäude in Schuss halten: Kontrolle, Reinigung, Pflege und kleine Reparaturen – alles aus einer Hand.',
  },
  {
    title: 'Grundreinigung',
    text: 'Bei der Grundreinigung entfernen wir selbst tiefsitzenden Schmutz, Staub und Ablagerungen – perfekt für Neubauten, Sanierungen oder saisonale Auffrischungen.',
  },
];

const Services = () => {
  return (
    <section
      className='services'
      id='services'>
      <div className='container'>
        <h2>
          Wir bieten ein umfassendes Spektrum an{' '}
          <span>Reinigungsdienstleistungen</span>
        </h2>

        <div className='services__grid'>
          {services.map((item, index) => (
            <div
              key={index}
              className='service-card__wrapper'>
              <div className='service-card'>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
              <div className='service-card__icon'>→</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
